<script setup lang="ts">
//
</script>

<template>
  <div class="customBodyInjectedScript"></div>
</template>
